import React, { useState } from "react";
import { Form } from "./Form";
import { signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth'

import { auth } from '../../firebase';
import HomeButton from "../../components/HomeButton";

const Login = () => {
    const [loginEmail, setLoginEmail] = useState("");
    const [loginPassword, setLoginPassword] = useState("");

    const [user, setUser] = useState({});

    onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser);
    })

    const login = async () => {
        try {
            const user = await signInWithEmailAndPassword(
                auth,
                loginEmail,
                loginPassword
            )
            alert(`Logado como: ${loginEmail}`)
            window.location.href = "/"
        } catch (error) {
            alert(error.message)
        }
    }

    return (
        <>
            <div className="container">
                <HomeButton />
                <div className="row text-center justify-content-center p-5">
                    <Form welcome={`Bem vindo(a)!`}
                        submitBtn={"Logar"}
                        setEmail={setLoginEmail}
                        setPassword={setLoginPassword}
                        login={login} />
                </div>
            </div>
        </>
        
    )
}

export default Login;